import { useRouter } from 'next/router';

const useGridGender = () => {
  const router = useRouter();
  const { query: { gridGender } = {} } = router;
  return gridGender;
};

export default useGridGender;
